export default __webpack_public_path__ + "static/media/partscreen.5931a97e.svg";